var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isTag)?_c('span',{class:{empty: _vm.empty,prettyText:true}},[(_vm.uiicon)?_c('Icon',{class:{empty_animate:this.animateIcon},attrs:{"type":_vm.uiicon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.localize(_vm.uitext)))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }